// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/pagination/style/index.less
// module id = 1030
// module chunks = 1